export const GA_TRACKING_ID = 'G-W3L8Z3XL2Z';

// Track pageviews
export const pageview = (url) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  } else {
    console.warn('gtag not loaded yet (pageview)');
  }
};

// Track custom events
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  } else {
    console.warn('gtag not loaded yet (event) build', action);
  }
};
